import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    const saved = localStorage.getItem('shedCart');
    return saved ? JSON.parse(saved) : [];
  });

  const [isCartOpen, setIsCartOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem('shedCart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (shed) => {
    setCartItems(prev => {
      const exists = prev.find(item => item.id === shed.id);
      if (exists) {
        return prev;
      }
      return [...prev, { ...shed, quantity: 1 }];
    });
    setIsCartOpen(true);
  };

  const removeFromCart = (shedId) => {
    setCartItems(prev => prev.filter(item => item.id !== shedId));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const isInCart = (shedId) => {
    return cartItems.some(item => item.id === shedId);
  };

  const getCartTotal = () => {
    return cartItems.reduce((total, item) => {
      const price = item.salePrice || item.price;
      return total + price;
    }, 0);
  };

  const getDepositTotal = () => {
    return getCartTotal() * 0.25;
  };

  const cartCount = cartItems.length;

  return (
    <CartContext.Provider value={{
      cartItems,
      cartCount,
      isCartOpen,
      setIsCartOpen,
      addToCart,
      removeFromCart,
      clearCart,
      isInCart,
      getCartTotal,
      getDepositTotal
    }}>
      {children}
    </CartContext.Provider>
  );
};

export default CartContext;
